'use client';

import React, { ChangeEvent } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
// import queryString from 'query-string';
import styled from 'styled-components';

import { InputSearch } from './InputSearch';

import { devices } from '@/styles/breakpoints';

export const HeadingBlog = ({ meta }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // const [inputValue, setValue] = useState('');

  // const searchValue = useDebounce(inputValue, 400);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    //     const inputValue = event.target.value;
    //
    //     setValue(inputValue);
    const term = event.target.value;
    const params = new URLSearchParams(searchParams);

    if (term) {
      params.set('search', term);
    } else {
      params.delete('search');
    }

    router.replace(`${pathname}?${params.toString()}`);
  };

  /*   const url = (search: number | string) => {
    if (!search) {
      return pathname;
    }
    return `?${queryString.stringify({
      search,
    })}`;
  }; */

  /* const handleSearch = () => {
    const newPath = url(inputValue);

    router.push(newPath);
  };

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter') return handleSearch();
  }; */

  // useEffect(() => {
  //   handleSearch();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchValue]);

  return (
    <Heading>
      <SummaryBlock>
        Result:<span>{meta?.total || 0}</span>
      </SummaryBlock>
      <InputBlock>
        <InputSearch
          inputValue={searchParams.get('search')?.toString()}
          defaultValue={''}
          // handleKeyPress={handleKeyPress}
          handleChange={handleChange}
          // handleSearch={handleSearch}
        />
      </InputBlock>
    </Heading>
  );
};
const Heading = styled.div`
  display: flex;
  flex-direction: column-reverse;

  gap: 16px;
  width: 100%;
  padding: 0;
  margin-bottom: 24px;
  & input {
    width: 100%;
  }
  @media only screen and ${devices.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    & input {
      width: 360px;
    }
  }
`;

const InputBlock = styled.div``;
const SummaryBlock = styled.div`
  color: #4d4d4d;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  & span {
    color: #192d52;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;
